const styles = (theme) => ({
  parcellist: {
    overflowY: "scroll",
    padding: 0,
  },
});

export default styles;
